var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOtherProvidersBackground = function SvgOtherProvidersBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 2124,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M129.756 677.385c-411.826 208.548-173.812 630.595-3.327 815.545 512.95 431.08 670.785-95.2 449.594-440.5-221.191-345.309 545.427-189.295 507.717-698.617-43.73-590.578-439.201 62.886-953.984 323.572Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M145.296 692.839c-418.853 194.049-195.714 624.141-31.787 814.931 497.593 448.72 673.698-71.73 464.693-424.54-209.005-352.818 551.708-170.144 531.788-680.472-23.09-591.745-441.127 47.52-964.694 290.081Z",
    opacity: 0.959
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M160.286 708.826c-425.37 179.313-217.376 616.934-60.208 813.324 481.63 465.82 675.791-48.17 479.226-408.07-196.565-359.89 557.306-150.779 555.216-661.491-2.43-592.19-442.521 32.096-974.234 256.237Z",
    opacity: 0.917
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M174.709 725.327C-256.66 889.685-64.066 1334.3 86.153 1536.06c465.08 482.33 677.061-24.56 493.176-391.1-183.886-366.533 562.231-131.24 577.961-641.714 18.24-591.915-443.369 16.632-982.581 222.081Z",
    opacity: 0.876
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M188.547 742.32c-436.842 149.204-259.882 600.27-116.796 807.15 447.963 498.27 677.506-.92 506.524-373.65-170.981-372.728 566.465-111.54 600.005-621.153 38.88-590.918-443.68 1.149-989.733 187.653Z",
    opacity: 0.835
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M201.784 759.787C-239.999 893.654-78.888 1350.62 56.89 1562.36c430.301 513.61 677.125 22.73 519.256-355.74-157.869-378.465 570.014-91.7 621.314-599.831 59.49-589.201-443.446-14.337-995.676 152.998Z",
    opacity: 0.794
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M214.403 777.705C-231.783 896.072-86.717 1358.38 41.588 1574.74c412.114 528.31 675.919 46.34 531.355-337.41-144.565-383.743 572.867-71.75 641.867-577.782 80.02-586.765-442.674-29.803-1000.407 118.157Z",
    opacity: 0.752
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M226.39 796.052C-223.656 898.776-94.813 1365.86 25.863 1586.57c393.426 542.37 673.89 69.9 542.807-318.66-131.084-388.555 575.02-51.71 661.64-555.029 100.45-583.616-441.364-45.234-1003.92 83.171Z",
    opacity: 0.711
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M237.728 814.806C-215.628 901.761-103.165 1373.06 9.736 1597.84c374.257 555.77 671.039 93.38 553.596-299.51-117.443-392.9 576.478-31.62 680.608-531.607 120.75-579.755-439.516-60.611-1006.212 48.083Z",
    opacity: 0.67
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M248.405 833.945c-456.115 71.08-360.168 546.015-255.18 774.605 354.632 568.49 667.371 116.74 563.711-280.02-103.66-396.752 577.234-11.47 698.754-507.523 140.9-575.188-437.141-75.913-1007.285 12.938Z",
    opacity: 0.629
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M258.408 853.444C-199.91 908.563-120.597 1386.56-23.651 1618.67c334.577 580.52 662.891 139.96 573.141-260.17-89.75-400.132 577.28 8.67 716.04-482.832 160.89-569.92-434.225-91.122-1007.122-22.224Z",
    opacity: 0.588
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M267.722 873.281c-459.962 39.09-397.379 519.559-308.593 754.909 314.113 591.85 657.603 163.02 581.872-240C465.27 985.167 1117.63 1417 1273.45 930.639c180.69-563.957-430.775-106.22-1005.728-57.358Z",
    opacity: 0.546
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M276.341 893.431c-461.047 23.014-415.27 505.379-334.752 743.689 293.267 602.44 651.513 185.86 589.893-219.56-61.619-405.42 575.268 48.92 747.978-431.706 200.25-557.308-426.812-121.19-1003.119-92.423Z",
    opacity: 0.505
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M284.252 913.869c-461.568 6.91-432.654 490.581-360.501 731.551 272.062 612.31 644.629 208.49 597.196-198.84-47.434-407.32 573.213 68.97 762.583-405.34 219.59-549.975-422.317-136.008-999.278-127.371Z",
    opacity: 0.464
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M291.442 934.571c-461.529-9.203-449.512 475.179-385.813 718.519 250.528 621.44 636.961 230.86 603.772-177.87s570.459 88.93 776.269-378.48c238.64-541.978-417.318-150.665-994.228-162.169Z",
    opacity: 0.422
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M297.908 955.512c-460.926-25.305-465.821 459.198-410.653 704.618 228.687 629.8 628.515 252.95 609.611-156.69s567.004 108.79 789.004-351.16c257.41-533.32-411.804-165.137-987.962-196.768Z",
    opacity: 0.381
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M303.636 976.665c-459.762-41.375-481.563 442.665-434.994 689.855 206.568 637.4 619.305 274.73 614.708-135.32s562.86 128.51 800.78-323.41C1560 683.781 878.339 1028.38 303.636 976.665Z",
    opacity: 0.34
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M308.625 998.005c-458.039-57.395-496.72 425.585-458.805 674.255 184.197 644.22 609.339 296.18 619.056-113.78s558.034 148.07 811.574-295.27c293.99-514.064-399.278-193.46-971.825-265.205Z",
    opacity: 0.299
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M312.865 1019.51c-455.756-73.349-511.269 407.99-482.057 657.83 161.602 650.26 598.633 317.26 622.651-92.11s552.521 167.46 821.381-266.76c311.76-503.494-392.28-207.28-961.975-298.96Z",
    opacity: 0.258
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M316.354 1041.14c-452.918-89.204-525.197 389.91-504.721 640.61 138.81 655.5 587.196 337.96 625.486-70.32s546.345 186.64 830.191-237.93c329.14-492.311-384.807-220.85-950.956-332.36Z",
    opacity: 0.216
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M319.083 1062.89c-449.53-104.962-538.485 371.33-526.771 622.6 115.849 659.95 575.043 358.25 627.559-48.45s539.499 205.59 837.989-208.81c346.12-480.524-376.865-234.14-938.777-365.34Z",
    opacity: 0.175
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M321.052 1084.71c-445.592-120.579-551.115 352.32-548.178 603.85 92.746 663.58 562.19 378.09 628.868-26.52 66.677-404.62 531.995 224.29 844.768-179.45 362.68-468.14-368.467-247.15-925.458-397.88Z",
    opacity: 0.134
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M322.259 1106.6c-441.113-136.064-563.076 332.87-568.918 584.34 69.531 666.42 548.652 397.49 629.41-4.56 80.758-402.04 523.843 242.73 850.519-149.85 378.79-455.2-359.62-259.86-911.011-429.93Z",
    opacity: 0.092
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M322.701 1128.51c-436.095-151.375-574.349 313.01-588.964 564.13 46.23 668.44 534.446 416.39 629.185 17.41 94.74-398.98 515.054 260.86 855.228-120.08 394.45-441.7-350.329-272.25-895.449-461.46Z",
    opacity: 0.051
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFD07D",
    strokeWidth: 0.5,
    d: "M322.379 1150.42c-430.547-166.499-584.924 292.78-608.294 543.23 22.874 669.65 519.588 434.79 628.194 39.36 108.607-395.43 505.636 278.68 858.901-90.15 409.62-427.68-340.617-284.31-878.801-492.44Z",
    opacity: 0.01
  })));
};
export default SvgOtherProvidersBackground;